export class WalletSummaryModel {
    walletId: string;
    totalPoints: number;
    totalValue: number;
    lifeTimePoints: number;
    totalTransactions: number;
    reedemPoints: number;
    segmentPoints: number;
    redeemValue: number;
    tierName: string;
    tierPoints: number;
    pointsToExpire:number;
    expiryDate:Date;
    walletStatusId: number;
    redeemFactor:  number;
  }
